module.exports = __webpack_public_path__ + "static/Resume-Christian-Santos-3837c5726153be7754cb82fac21a300c.pdf";